import { toast } from "react-toastify";
import axiosConfig from "../axiosConfig.js";

class DocumentService {
    getIdentity = async (token) => {
        try {
            const response = await axiosConfig.get(`document/getIdentity`);
            return response;
        } catch (error) {
            // Show the error message as a toast notification
            toast.error(error?.message);
        }
    };
    getInsurance = async (token) => {
        try {
            const response = await axiosConfig.get(`document/getInsurance`);
            return response;
        } catch (error) {
            // Show the error message as a toast notification
            toast.error(error?.message);
        }
    };
    uploadDocument = async (postId) => {
        try {
            const response = await axiosConfig.post(`document/upload/`);
            return response;
        } catch (error) {
            // Show the error message as a toast notification
            toast.error(error?.message);
            // throw new Error(error);
        }
    };
    uploadInsuranceDocs = async (requestBody, token) => {
        try {
            const response = await axiosConfig.post(`document/upload/insuranceDocs`, requestBody);
            return response;
        } catch (error) {
            // Show the error message as a toast notification
            toast.error(error?.message);
            // throw new Error(error);
        }
    };
    uploadDocs = async (requestBody, token, isQuestionnaire) => {
        try {
            const response = await axiosConfig.post(`document/upload`, requestBody);
            return response;
        } catch (error) {
            // Show the error message as a toast notification
            if(!isQuestionnaire){
                toast.error(error?.message);
            }
            // throw new Error(error);
        }
    };
    
}

const instance = new DocumentService();

export default instance;
